import { useState } from 'react'
import { ActionIcon, Button, Menu } from '@mantine/core'
import { IconPlus, IconX } from '@tabler/icons-react'
import TableFilter from './TableFilter'

export default function TableViewFilters({ availableFilters, filters, changeFilters }) {
    const [addedKeys, setAddedKeys] = useState([])
    const keys = [...new Set([...Object.keys(filters), ...addedKeys])]
    const remaining = availableFilters.filter((filter) => !keys.includes(filter.key))
    const changeFilter = (key, value) => {
        setAddedKeys((previous) => [...new Set([...previous, key])])
        const next = { ...filters }
        if (value == null || value === '' || (Array.isArray(value) && !value.length)) delete next[key]
        else next[key] = value
        changeFilters(next)
    }
    const removeFilter = (key) => {
        setAddedKeys((previous) => previous.filter((item) => item !== key))
        const next = { ...filters }
        delete next[key]
        changeFilters(next)
    }
    if (!availableFilters.length && !keys.length) return null

    return <div className="border-b py-3">
        <div className="mb-3 flex items-center justify-between gap-2">
            <span className="text-sm">Filtres</span>
            <Menu position="bottom-end" withinPortal={false}>
                <Menu.Target>
                    <Button variant="subtle" color="gray" size="compact-sm" leftSection={<IconPlus size={14} />} disabled={!remaining.length}>Ajouter un filtre</Button>
                </Menu.Target>
                <Menu.Dropdown style={{ maxHeight: 260, maxWidth: 'calc(100vw - 48px)', overflowY: 'auto' }}>
                    {remaining.map((filter) => <Menu.Item key={filter.key} onClick={() => setAddedKeys((previous) => [...previous, filter.key])}>{filter.name}</Menu.Item>)}
                </Menu.Dropdown>
            </Menu>
        </div>
        <div className="flex flex-col gap-3">
            {keys.map((key) => {
                const filter = availableFilters.find((item) => item.key === key)
                return <div key={key} className="flex items-end gap-2">
                    <div className="min-w-0 flex-1">
                        {filter ? <TableFilter filter={filter} tableState={{ filters }} changeFilter={changeFilter} />
                            : <span className="text-sm text-gray-500">Filtre indisponible</span>}
                    </div>
                    <ActionIcon className="mb-1 shrink-0" variant="subtle" color="gray" aria-label={`Supprimer le filtre ${filter?.name ?? key}`} onClick={() => removeFilter(key)}><IconX size={16} /></ActionIcon>
                </div>
            })}
            {!keys.length && <p className="text-xs text-gray-500">Aucun filtre.</p>}
        </div>
    </div>
}
